import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { BrowserRouter } from "react-router";

//
import "./i18n";
import GlobalStyle from "./assets/css/global";
import Router from "./router/Router";


function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <SpeedInsights />
      <GlobalStyle />
      <Router />
    </BrowserRouter>
  );
}

export default App;
